// extracted by mini-css-extract-plugin
export var currentStep = "_g7-2";
export var nodeCard = "_g7-0";
export var pathHighlighted = "_g7-1";